import * as Segment from './tools/segment';
import * as hotjarTracking from './tools/hotjar';

import { extractSiteGroupingProps } from './utils';
import type { TrackingSite } from './utils';

interface ExperimentViewedArgs {
  experimentId: string;
  experimentTargetId: string;
  variationId: string | number;
  userId?: string;
  site?: TrackingSite;
}

/**
 * Track in Segment that an Optimizely experiment has been viewed.
 */
export const experimentViewed = ({
  experimentId,
  experimentTargetId,
  variationId,
  userId,
  site,
}: ExperimentViewedArgs): void => {
  const data = {
    experiment_id: experimentId,
    experiment_target_id: experimentTargetId,
    variation_id: variationId,
    ...(site && extractSiteGroupingProps(site)),
    ...(typeof userId !== 'undefined' && { user_id: userId }),
  };

  hotjarTracking.tagRecording(`${experimentId}_${variationId}`);
  Segment.track('Experiment Viewed', data);
};
